<template>
  <div class="enu-button" v-if="render">
    <template
      v-if="buttonsDef.length"
      v-for="buttonDef in buttonsDef"
    >
      <button
        v-if="buttonDef.ViewName !== 'cstTask_Action_Navigate'"
        :class="['btn', buttonDef.CSSClass]"
        :disabled="buttonDef.hasOwnProperty('IsReadOnly') && buttonDef.IsReadOnly"
        @click="_clickListener(buttonDef, $event)">
        {{ t(buttonDef.Label) }}
      </button>
      <a
        v-if="buttonDef.ViewName === 'cstTask_Action_Navigate'"
        :class="['btn', buttonDef.CSSClass]"
        :href="_getButtonTarget(buttonDef)"
        target="_blank"
      >
        {{ t(buttonDef.DictionaryKeyCode) }}
      </a>
    </template>
  </div>
</template>

<script>
import ResourceGetter  from '../../../model/resource/getter/resource-getter'
import ResponseEvents  from '../../../model/event-handlers/response-bussines-rules-events'
import CartRefresh     from '../../../model/event-handlers/cart-refresh-event'
import Swal            from 'sweetalert2/dist/sweetalert2.js'
import interpretations from '../../../model/interpretations'
import Bootbox         from '../../../model/Bootbox'
import Button          from '../../grids/renderers/grid-form/elements/button'

export default {
  name:       'form-action-button',
  components: { Button },
  props:      {
    buttonsDef:        {
      type:    Array,
      default: () => {
        return []
      }
    },
    def:               {
      type:    Object,
      default: () => {
        return {}
      }
    },
    propParent:        {
      type:    Object,
      default: () => {
        return null
      }
    },
    data:              {
      type:    Object,
      default: () => {
        return null
      }
    },
    updateDataRequest: {
      type:    Function,
      default: null
    },
    formDataChanged:   {
      type:    Function,
      default: null
    },
    enableSaveFormHook:   {
      type:    Boolean,
      default: false
    },
  },

  data () {
    return {
      render: true,
      innerButtons: {}
    }
  },

  created () {
    this.applyDataFilter()
  },

  watch: {
    'data' () {
      this.applyDataFilter()
    }
  },

  methods: {

    _getButtonTarget (buttonSpecifications) {
      if (buttonSpecifications.ViewName === 'cstTask_Action_Navigate') {
        return 'https://www.google.com/maps/dir/?api=1&destination=' +
          this.data['ADDRESSLATITUDE'] + '%2C' +
          this.data['ADDRESSLONGITUDE']
      }
    },

    /**
     * @TODO: data must be refactored -> hacked for time saving
     * @param buttonDef
     * @param event
     * @private
     */
    async _clickListener (buttonDef, event) {
      event.stopPropagation()

      if (buttonDef.IsReadOnly && this.innerButtons[buttonDef.Code].IsReadOnly) {
        return
      }

      const process = () => {
        const where    = '',
              data     = this.data ? this.data : (this.propParent
                ? this.propParent.$refs.form.getValues().getValuesTransformed()
                : this.$parent.$parent.getValues().getValuesTransformed()),
              resource = ResourceGetter.get(this.def.viewName)

        let args = {
          ruleType: 'Action',
          ruleName: buttonDef.ViewName,
          where:    where,
          value:    data
        }
        resource
          .setDef(this.def)
          .callBusinessRule(args)
          .then((response) => {
            if (buttonDef.Interpretation === 'Report') {
              let html = response.data.values.HTML

              this.$router.push({
                name:   'PageDynamicEditorPrint',
                params: {
                  content:   html,
                  resource:  resource,
                  buttonDef: buttonDef,
                  data:      this.data
                }
              })
              return
            }

            if (response.data && response.data.values.hasOwnProperty(ResponseEvents.cartRefresh) &&
              response.data.values[ResponseEvents.cartRefresh] === 1) {
              CartRefresh.exec()
            }

            if (response.data.messages) {
              Swal.fire(response.data.messages, '')
            }

            if (this.updateDataRequest) {
              this.updateDataRequest(null, this.data)
            }
            this.$emit('actionSend', this.data)
          })
          .catch((error) => {
            if (this.updateDataRequest) {
              this.updateDataRequest(null, this.data)
            }
            this.$emit('actionSend', this.data)
            this.handleApiError(error)
          })
      }

      const callback = () => {
        return new Promise((resolve, reject) => {
          if (buttonDef.Interpretation === interpretations.buttonS) {
            Bootbox.message    = this.$translate.text('cfm_confirm_message') +
              ' "' + this.$translate.text(buttonDef.Label) + '" ?'
            Bootbox.title      = this.$translate.text('cfm_confirm') + ' ?'
            Bootbox.translator = this.$translate
            Bootbox.init(() => {
              if (!this.enableSaveFormHook) {
                process()
              }
              resolve(true)
            }, () => {
              resolve(false)
            })

          }
          else {
            if (!this.enableSaveFormHook) {
              process()
            }
            resolve(true)
          }
        })
      }

      if (this.enableSaveFormHook) {
        this.$emit('saveFormHook', callback, process)
        return
      }

      if (this.formDataChanged) {
        this.formDataChanged(callback)
        return
      }

      await callback()
    },

    applyDataFilter () {
      if (!this.data) {
        return
      }

      this.def.filterByData(this.data)
      for (const button of this.buttonsDef) {
        for (const keyFilter in this.def.dataFilters) {
          if (keyFilter.includes(button.Code.toUpperCase())) {
            if (parseInt(this.def.dataFilters[keyFilter]) === 2) {
              this.render = false
            }
            if (parseInt(this.def.dataFilters[keyFilter]) === 1) {
              this.render       = true
              button.IsReadOnly = 'true'
            }
            if (parseInt(this.def.dataFilters[keyFilter]) === 0) {
              this.render       = true
              button.IsReadOnly = false
            }
          }
        }

        this.innerButtons[button.Code] = {IsReadOnly: button.IsReadOnly}
      }
    }
  }
}
</script>

<style scoped>
.enu-button {
  margin-bottom: 5px;
}
</style>
